import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType, ref } from 'vue';
import {
  ICapSuaChuaResponseBase,
  ITaiKhoanKeToanResponse,
} from '@/core/interfaces/ApiResponses';
import { useDateTime } from '@/core/hooks/use-date-time-hook';
import {
  setCurrentPageTitle,
  setBreadcrumbLinks,
} from '@/core/helpers/breadcrumb';
import PageContentSection from '@/layout/_shared/PageContentSection.vue';
import ResponsiveLayout from '@/layout/_shared/ResponsiveLayout.vue';
import LabelCustom from '@/components/shared/label-custom/LabelCustom.vue';
import DetailTopicLottie from '@/components/shared/detail-topic-lottie/DetailTopicLottie.vue';
// import DinhMucCoDinhTable from '@/components/dinh-muc-co-dinh/dinh-muc-co-dinh-table/DinhMucCoDinhTable.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CapSuaChuaDetail',
  props: {
  capSuaChuaDetail: {
    type: Object as PropType<ICapSuaChuaResponseBase>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { formatDisplayingDate } = useDateTime();

const taiKhoanDisplay = ({ matk, mact, tentk }: ITaiKhoanKeToanResponse) =>
  `${matk} / ${mact || '-'} / ${tentk}`;

const data = ref<ICapSuaChuaResponseBase>(props.capSuaChuaDetail);

setCurrentPageTitle(data.value.ten_cap_sc);
setBreadcrumbLinks([
  {
    text: 'Cấp sửa chữa',
    routeData: {
      name: 'danh-sach-cap-sua-chua',
    },
  },
  {
    text: 'Chi tiết',
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageContentSection, { "always-expanded": true }, {
    header: _withCtx(() => [
      _createTextVNode("Thông tin chi tiết")
    ]),
    illustration: _withCtx(() => [
      _createVNode(DetailTopicLottie, { topic: "ke-hoach-sua-chua" })
    ]),
    default: _withCtx(() => [
      _createVNode(ResponsiveLayout, null, {
        "col-1": _withCtx(() => [
          _createVNode(LabelCustom, { "is-text-muted": "" }, {
            default: _withCtx(() => [
              _createTextVNode("ID:")
            ]),
            _: 1
          })
        ]),
        "col-2": _withCtx(() => [
          _createVNode(LabelCustom, { "is-bolder": "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(data.value.id), 1)
            ]),
            _: 1
          })
        ]),
        "col-3": _withCtx(() => [
          _createVNode(LabelCustom, { "is-text-muted": "" }, {
            default: _withCtx(() => [
              _createTextVNode("Tên:")
            ]),
            _: 1
          })
        ]),
        "col-4": _withCtx(() => [
          _createVNode(LabelCustom, { "is-bolder": "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(data.value.ten_cap_sc), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(ResponsiveLayout, null, {
        "col-1": _withCtx(() => [
          _createVNode(LabelCustom, { "is-text-muted": "" }, {
            default: _withCtx(() => [
              _createTextVNode("Ngày tạo:")
            ]),
            _: 1
          })
        ]),
        "col-2": _withCtx(() => [
          _createVNode(LabelCustom, { "is-bolder": "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(formatDisplayingDate)(new Date(data.value.created_at))), 1)
            ]),
            _: 1
          })
        ]),
        "col-3": _withCtx(() => [
          _createVNode(LabelCustom, { "is-text-muted": "" }, {
            default: _withCtx(() => [
              _createTextVNode("Ngày cập nhật:")
            ]),
            _: 1
          })
        ]),
        "col-4": _withCtx(() => [
          _createVNode(LabelCustom, { "is-bolder": "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(formatDisplayingDate)(new Date(data.value.updated_at))), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(ResponsiveLayout, null, {
        "col-1": _withCtx(() => [
          _createVNode(LabelCustom, { "is-text-muted": "" }, {
            default: _withCtx(() => [
              _createTextVNode("T/khoản kế toán:")
            ]),
            _: 1
          })
        ]),
        "col-2": _withCtx(() => [
          _createVNode(LabelCustom, { "is-bolder": "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(taiKhoanDisplay(data.value.tk_ketoan)), 1)
            ]),
            _: 1
          })
        ]),
        "col-3": _withCtx(() => [
          _createVNode(LabelCustom, { "is-text-muted": "" }, {
            default: _withCtx(() => [
              _createTextVNode("Mô tả:")
            ]),
            _: 1
          })
        ]),
        "col-4": _withCtx(() => [
          _createVNode(LabelCustom, { "is-bolder": "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(data.value.mo_ta || '-'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})